import React from 'react';
import { Form, useAccordionToggle} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function CustomTextArea(props) {
    return(
        <>
        <span style={{color:'#80949D'}}>{props?.label}</span>
        <Form.Group controlId={props?.id}>
        <Form.Control as="textarea"  rows={props?.rows?props.rows:'4'} placeholder={props?.placeholder} defaultValue={props?.value} onChange={props?.onChange}/>        <Form.Text className="text-danger">
          {props.errorText}
        </Form.Text>
      </Form.Group>
      </>
    )
}

// How to use

// <CustomTextArea
// label={'Description :'}
// rows={5}
// />

